import React, { useState } from "react";
import { connect } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import {
  setNewDataLead,
  setPopupActivity,
  setSelectedLead,
} from "../../redux/reduxActions/leadActions";
import api from "../../api";

const FolderAndEstimationPopup = (props) => {
  const { selectedLead, isPopupOpened, isFolderSetter } = props;
  const [link, setLink] = useState("");
  const [isLinkBody, setLinkBody] = useState(true);
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  function closePopup() {
    props.setPopupActivity();
    setTimeout(() => {
      setLinkBody(true);
    }, 200);
  }
  function updateExternalData() {
    let params;
    if (isFolderSetter) {
      params = { project_folder: link };
    } else {
      params = { estimation_file: link };
    }
    props
      .setNewDataLead(selectedLead.id, params, props.history.push, false, true)
      .then(() => {
        toast.success("You successfully set new link!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2500,
        });
        closePopup();
        props.needUpdateData();
        setButtonDisabled(false);
        // props.setSelectedLead({});
      });
  }

  function setLinkProps(data) {
    setLink(data);
  }
  const createFolderOrLink = (id) => {
    setButtonDisabled(true);
    const params = { lead_id: id };
    if (isFolderSetter) {
      api.post("leadFolder", params).then(() => {
        props.needUpdateData();
        closePopup();
        // props.setSelectedLead({});
        setButtonDisabled(false);
      });
    } else {
      api.post("leadFile", params).then(() => {
        props.needUpdateData();
        // props.history.push('/lead-list');
        closePopup();
        // props.setSelectedLead({});
        setButtonDisabled(false);
      });
    }
  };
  return (
    <div>
      {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
      <Modal show={isPopupOpened} onHide={closePopup}>
        <Modal.Header closeButton>
          <Modal.Title>
            {isFolderSetter
              ? "Enter the link to the project folder"
              : "Enter the link to the project estimation file"}
          </Modal.Title>
        </Modal.Header>
        {isLinkBody ? (
          <ChooseTypeOfSetter
            id={selectedLead.id}
            isButtonDisabled={isButtonDisabled}
            isFolderSetter={isFolderSetter}
            createFilderOrLink={createFolderOrLink}
            setLinkBody={() => {
              setLinkBody(false);
            }}
          />
        ) : (
          <InnerLinkSetterPopup
            isFolderSetter={isFolderSetter}
            setLink={setLinkProps}
          />
        )}
        <Modal.Footer>
          {!isLinkBody ? (
            <Button
              variant="secondary"
              onClick={() => {
                setLinkBody(true);
              }}
            >
              Back
            </Button>
          ) : (
            <Button
              variant="secondary"
              onClick={() => {
                closePopup();
              }}
            >
              Close
            </Button>
          )}
          {!isLinkBody ? (
            <Button
              variant="primary"
              onClick={() => updateExternalData()}
              className="main-button-filled"
            >
              Save Link
            </Button>
          ) : null}
        </Modal.Footer>
      </Modal>
    </div>
  );
};
const mapStateToProps = (state) => ({
  selectedLead: state.leadReducer.selectedLead,
  isPopupOpened: state.leadReducer.isPopupOpened,
  isPopupOpened: state.leadReducer.isPopupOpened,
  isFolderSetter: state.leadReducer.isFolderSetter,
});
export default connect(mapStateToProps, {
  setPopupActivity,
  setNewDataLead,
  setSelectedLead,
})(FolderAndEstimationPopup);

const InnerLinkSetterPopup = (props) => {
  const { isFolderSetter } = props;
  return (
    <Modal.Body>
      <div style={{ display: "flex" }}>
        <Form.Group style={{ width: "100%" }} controlId="formGridState">
          <Form.Control
            onChange={({ target: { value } }) => props.setLink(value)}
            type="text"
            placeholder={
              isFolderSetter
                ? "Link to project folder"
                : "Link to estimation file"
            }
          />
        </Form.Group>
      </div>
    </Modal.Body>
  );
};

const ChooseTypeOfSetter = (props) => {
  const { isFolderSetter, id, isButtonDisabled } = props;
  return (
    <Modal.Body>
      <Button
        variant="primary"
        onClick={() => props.setLinkBody()}
        className="main-button-filled"
        style={{ width: "-webkit-fill-available", marginBottom: 16 }}
      >
        {isFolderSetter ? "Set Folder Link" : "Set Estimation File Link"}
      </Button>
      <Button
        variant="primary"
        onClick={() => {
          props.createFilderOrLink(id);
        }}
        disabled={isButtonDisabled}
        className="main-button-filled"
        style={{ width: "-webkit-fill-available" }}
      >
        {isFolderSetter ? "Create Folder" : "Create Estimation File"}
      </Button>
    </Modal.Body>
  );
};
